/**
 * @desc 物料-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.PlmSkuRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/exportMaterialExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
